import React from "react";
import "./banner.css";
import { withRouter} from "react-router-dom";
import { directDeepLink, SOURCE_HOME } from "./util";
import { config } from '../../appConfig';
import campaignConfig from '../../campaign-config/campaign.json';

// temp
function Banner(props) {
	let url = new URL(window.location.href);
	const token = url.searchParams.get("token");
	const baseUrl = config.BANNER_URL;
	const images = campaignConfig.student_banner?.images || {};
	let deepLink = {
		screen: 'UTIL_WEBVIEW',
		paramOne: `${baseUrl}/student/?token=${token}`,
		paramTwo: '',
		paramTracking: 'StudentSideBannerClickTracking',
		paramThree: '',
		paramSource: '',
	};
	function bannerClicked(){
		directDeepLink(deepLink, SOURCE_HOME);
	}

  return (
    <div className="layoutBanner">
      <div className="Banner" onClick={bannerClicked}>
		  {/*<Lottie options={bannerAnimation}  />*/}
		  <img src={images.banner_artwork} alt="banner"/>
      </div>
    </div>
  );
}
export default withRouter(Banner);
